import { message, Modal, Table, Space, Button, Select, Form, Input, Pagination, DatePicker, InputNumber, Tabs } from "antd";
import { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { getMonthStartEnd, formatNumber, formatDate, dayjsDate, getobjkeys, formatDate2, checkp } from '../../utils/functions'
import { PlusOutlined, EditOutlined, DeleteOutlined, DiffOutlined } from '@ant-design/icons';
import CustModal from "../../components/ShowModal";
import ShEditor from "../../components/ShEditor";

function Khxxsp() {
    const { type } = useParams();
    const webPost = useWebPost();
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [dataAll, setDataAll] = useState([]);
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const pageSizeOptions = [10, 20, 50, 100, 500];

    const [form] = Form.useForm();
    const [editingRecord, setEditingRecord] = useState(null);
    const [activeKey, setActiveKey] = useState('0');
    const [tablekey, setTablekey] = useState('0');

    const loadingRef = useRef();
    useEffect(() => {
        const fetchItems = () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            try {
                const params = { page: currentPage, limit: pageSize, ...filters, type, s: activeKey };

                webPost('customerinfosp', params).then((response) => {
                    if (response) {
                        setDataAll(response);
                        setTotal(response.length);
                        const fdata = Array.from(response.slice(0, pageSize));

                        setTablekey(Math.random())
                        setData(fdata);
                    }
                })
            } catch (e) {
                setData([]);
                setDataAll([]);
                setTotal(0);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        }
        fetchItems();
    }, [filters, freshData, activeKey, type]);

    const columns = [
        {
            title: '序号',
            dataIndex: 'xd',
            key: 'xd',
            width: 80,
            fixed: 'left',
            render: (text, record, rowIndex) => {
                return rowIndex + 1 + (currentPage - 1) * pageSize;
            },
        },
        { title: '年份', dataIndex: 'co_date', width: 120 },
        { title: '项目编号', dataIndex: 'sn', width: 140 },
        { title: '项目名称', dataIndex: 'xmmc', width: 220, ellipsis: { showTitle: true, } },
        { title: '填报企业', dataIndex: 'com_tianbao', width: 160, ellipsis: { showTitle: true, }, },
        {
            title: '参与/中标/自营', dataIndex: 'type', width: 160, ellipsis: { showTitle: true, }, render: (v) =>
                <div
                    style={{
                        width: '100%',
                        whiteSpace: 'pre-wrap', // 解析换行符（\n）
                        wordBreak: 'break-all', // 超长字符换行
                        lineHeight: '1.4', // 行高适配
                        padding: '2px 0', // 内边距优化
                        overflow: 'hidden' // 配合ellipsis，超出宽度隐藏
                    }}
                >
                    {v || '-'} {/* 空值显示占位符 */}
                </div>
        },
        { title: '合同类型', dataIndex: 'co_type', width: 120, },
        { title: '业主名称', dataIndex: 'customer_name', width: 180, ellipsis: { showTitle: true, }, },
        { title: '业主性质', dataIndex: 'customer_nature', width: 120, },
        { title: '所属行业/专业', dataIndex: 'zylx', width: 120, },
        { title: '预计合同额(万元)', dataIndex: 'amount', width: 120, render: (v) => formatNumber(v / 10000) },
        { title: '实际合同额(万元)', dataIndex: 'sjamount', width: 120, render: (v) => formatNumber(v / 10000) },
        { title: '税率（%）', dataIndex: 'sl', width: 100, },
        { title: '项目地点', dataIndex: 'location', width: 100, ellipsis: { showTitle: true, } },
        { title: '项目规模', dataIndex: 'xmgm', width: 100, ellipsis: { showTitle: true, } },
        { title: '合同范围', dataIndex: 'htfw', width: 100, ellipsis: { showTitle: true, } },
        { title: '投标月份', dataIndex: 'tbdate', width: 120, },
        { title: '业绩归属', dataIndex: 'ywname', width: 100, },
        { title: '填报人', dataIndex: 'creator', width: 100, },
        { title: '填报时间', dataIndex: 'create_time', width: 120, },
        { title: '客户名称/电话', dataIndex: 'wt_phone', width: 120, ellipsis: { showTitle: true, } },
        { title: '业主负责人/电话', dataIndex: 'customer_phone', width: 120, ellipsis: { showTitle: true, } },
        { title: '项目负责人', dataIndex: 'xmfz', width: 120, ellipsis: { showTitle: true, } },
        { title: '项目状态', dataIndex: 'xmzt', width: 100, ellipsis: { showTitle: true, } },
        { title: '是否录入业绩', dataIndex: 'islr', width: 100, ellipsis: { showTitle: true, } },
        { title: '备注', dataIndex: 'ps', width: 100, ellipsis: { showTitle: true, } },
        (activeKey==='1') && { title: '审核人',fixed: 'right', dataIndex: 'auditor', width: 100, ellipsis: { showTitle: true, } },
        (checkp(['xmxxsp1']) || checkp(['xmxxsp2']) || checkp(['xmxxsp3'])) && activeKey!=='1' && {
            title: '操作',
            key: 'action',
            width: 160,
            fixed: 'right',
            render: (_, record) => <Button type="link" onClick={() => showModal(record, "scbs")} >开始审核</Button>,
        },
    ].filter(Boolean);

    const showModal = async (record = null, action) => {
        if (!record) {
            message.error("错误的参数");
            return;
        }
        setEditingRecord(record);
        setModalVisible(action);
    };
    const handleModalClose = () => {
        setModalVisible('');
        setEditingRecord(null);
    }
    const saveSuccess = async (r) => {
        if (!editingRecord?.sn) return message.error("错误的参数");
        const params = { sn: editingRecord?.sn, type, ...r, id: editingRecord.id };
        const res = await webPost('customerinfospsave', params);
        if (res) {
            message.success(editingRecord ? '更新成功' : '新增成功');
            setfreshData(Math.random()); //强制刷新数据
            handleModalClose();
        }
    };
    const onPageChange = (page, size) => {
        let cp=page;
        if (size !== pageSize) {
            setPageSize(size);
            setCurrentPage(1);
            cp=1;
        } else {
            setCurrentPage(page);
        }
        
        if (total > 0) {
            const start = (cp - 1) * size;
            const end = start + size;
            const currentData = dataAll.slice(start, end);
            console.log('sfdsffsdf',dataAll,start,end,currentData);
            setData([...currentData]);
        }
    };
    return (
        <FullHeightLayout
            headerContent={null}
            bodyContent={
                <>
                    <Tabs activeKey={activeKey} onChange={setActiveKey} style={{ 'padding': '0 10px' }}>
                        <Tabs.TabPane key='0' tab='待审核'>
                        </Tabs.TabPane>
                        <Tabs.TabPane key='-1' tab='已拒绝'>
                        </Tabs.TabPane>
                        <Tabs.TabPane key='1' tab='通过审核'>
                        </Tabs.TabPane>
                    </Tabs>

                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey={(record, index) => index}
                        loading={loading}
                        pagination={false}
                        bordered
                        scroll={{
                            x: 2940,
                            y: 'calc(100vh - 300px)',
                        }}
                        tableLayout="fixed"
                    />
                    <Modal
                        title={'审核结果'}
                        open={modalVisible === 'scbs'}
                        onCancel={handleModalClose}
                        okText="保存"
                        cancelText="取消"
                        footer={null}
                    >
                        <ShEditor onChange={saveSuccess} >
                            <div>审核备注1：{editingRecord?.audit_comment || '无'}</div>
                        </ShEditor>
                    </Modal>

                </>
            }
            footerContent={
                <div style={{
                    display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={total}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                        onChange={onPageChange}
                        pageSizeOptions={pageSizeOptions}
                    />
                </div>
            }
        />
    )
}


export default Khxxsp;
